import React from 'react';
import '../styles/MarqueeStrip.css';

const ITEMS = [
  ' ',
  '✦',
  ' ',
  '✦',
  ' ',
  '✦',
  ' ',
  '✦',
  ' ',
  '✦',
  ' ',
  '✦',
  ' ',
  '✦',
  ' ',
  '✦',
   ' ',
  '✦',
  ' ',
  '✦',
  ' ',
  '✦',
  ' ',
  '✦',
  ' ',
  '✦',
  ' ',
  '✦',
  ' ',
  '✦',
  ' ',
  '✦',
   ' ',
  '✦',
  ' ',
  '✦',
  ' ',
  '✦',
  ' ',
  '✦',
  ' ',
  '✦',
  ' ',
  '✦',
  ' ',
  '✦',
  ' ',
  '✦',
   ' ',
  '✦',
  ' ',
  '✦',
  ' ',
  '✦',
  ' ',
  '✦',
  ' ',
  '✦',
  ' ',
  '✦',
  ' ',
  '✦',
  ' ',
  '✦',
];

function MarqueeStrip() {
  const repeated = [...ITEMS, ...ITEMS];

  return (
    <div className="marquee-strip-wrap">
      <div className="marquee-strip">
        <div className="marquee-track">
          {repeated.map((item, i) => (
            <span key={i} className={item === '✦' ? 'marquee-dot' : 'marquee-item'}>
              {item}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}

export default MarqueeStrip;
